import { render } from "./ChosenFieldset.vue?vue&type=template&id=0a5ff4b5"
import script from "./ChosenFieldset.vue?vue&type=script&lang=js"
export * from "./ChosenFieldset.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__